module.exports = __webpack_public_path__ + "media/images/mailers/welcome_email/point_right-f27b00b5cf1b4b2e3485618cb71e00ab.png";